import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import { accessKeyIdZodSchema } from "./access-key-id";

const removeAccessKeyCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("REMOVE_ACCESS_KEY_COMMAND"),
    accessKeyId: accessKeyIdZodSchema,
    ownerId: providerIdZodSchema,
});
type RemoveAccessKeyCommand = z.infer<typeof removeAccessKeyCommandZodSchema>;

const removeAccessKeyCommandFactory = (
    params: Except<RemoveAccessKeyCommand, "_id" | "_type">,
): RemoveAccessKeyCommand => {
    return {
        _id: generateId({ prefix: "remove_access_key_command__" }),
        _type: "REMOVE_ACCESS_KEY_COMMAND",
        ...params,
    };
};

export { removeAccessKeyCommandFactory, removeAccessKeyCommandZodSchema };
export type { RemoveAccessKeyCommand };
